import { Component, OnInit } from '@angular/core';
import { GlobalService } from '../global.service';
import { ActivatedRoute, Router } from '@angular/router';
import { LoadingScreenService } from '../services/loading-screen/loading-screen.service';
import { AngularFireAnalytics } from '@angular/fire/analytics';
import { MatDialog, MatDialogConfig } from '@angular/material';
import { PopChannelsComponent } from 'src/app/components/pop-channels/pop-channels.component';
import { Service } from '../services';
import { PopUpTermsOffersComponent } from './components/plan-selection-iptv/components/pop-up-terms-offers/pop-up-terms-offers.component';
interface channelList {
  idPlan: number,
  channels: []
}
@Component({
  selector: 'app-iptv',
  templateUrl: './iptv.component.html',
  styleUrls: ['./iptv.component.sass']
})
export class IptvComponent implements OnInit {
  public myPlans = [];
  public myPlansData = [];
  public channelGuideList = [];
  public channelGuideListData = [];
  public channelList: any = [];
  public tabActive = 'Mis Equipos y Servicios';
  public currentList;
  public postpago;
  public prepago;
  public telefoniaFijo;
  public totalAccountList;
  public selectBan;
  public token: string = sessionStorage.getItem("token");
  public actualViewStep;
  public idPlan: string;
  public loadTokenSSO:boolean=false;
  public checkIptv:boolean=true;
  constructor(private services: Service, public dialog: MatDialog, public AngularFireAnalytics: AngularFireAnalytics, public global: GlobalService, private router: Router, private loadingScreenService: LoadingScreenService, private route: ActivatedRoute) {
    this.AngularFireAnalytics.setCurrentScreen("iptv");
    this.AngularFireAnalytics.logEvent("Iptv-Screenview");
    let w: number;
    this.global.resizeObservable.subscribe((e: any) => {
      if (e.target.innerWidth !== w) {
        this.carouselSetup();
      }
      w = e.target.innerWidth;
    });
  }
  ngOnInit() {
    this.global.validateSession();
    this.dataLoading();

  }
  dataLoading() {
    this.loadingScreenService.startLoading();
    this.services.listCatalogue(this.token, 11, 1, 100, "", "", "", 0, "", "").subscribe((data: any) => {
      this.myPlansData = data.catalogs[2].catalog[0].products;
      this.carouselSetup();
      this.loadChannelsList();
    });
  }
  loadChannelsList() {
    for (let i = 0; i < this.myPlans.length; i++) {
      for (let j = 0; j < this.myPlans[i].length; j++) {
        this.services.channelsList(this.token, this.myPlans[i][j].productId,0, 8).subscribe((data: any) => {
          let json: channelList = {
            idPlan: this.myPlans[i][j].productId,
            channels: data
          }
          this.channelList.push(json);
        });
      }
    }
    this.loadingScreenService.stopLoading();
    this.loadTokenSSO=true;
  }
  carouselSetup() {
    if (window.innerWidth > 864) {
      this.myPlans = this.global.createAdaptiveJson(this.myPlans, this.myPlansData, 3);
      this.channelGuideList = this.global.createAdaptiveJson(this.channelGuideList, this.channelGuideListData, 10);
    }
    else if (window.innerWidth > 640 && window.innerWidth <= 864) {
      this.myPlans = this.global.createAdaptiveJson(this.myPlans, this.myPlansData, 2);
      this.channelGuideList = this.global.createAdaptiveJson(this.channelGuideList, this.channelGuideListData, 6);
    }
    else {
      this.myPlans = this.global.createAdaptiveJson(this.myPlans, this.myPlansData, 1);
      this.channelGuideList = this.global.createAdaptiveJson(this.channelGuideList, this.channelGuideListData, 2);
    }
  }
  jsonChannels(idPlan: number) {
    for (let i = 0; i < this.channelList.length; i++) {
      if (this.channelList[i].idPlan == idPlan) {
        return this.channelList[i].channels;
      }
    }
  }
  goToChannelList(id: number = 0, name: string = '') {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { planId: id, planName: name };
    const dialogRef = this.dialog.open(PopChannelsComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(value => {
    });
  }
  initializeData() {
    this.global.refreshDataTo(this.token);
  }
  selectPlan(id: string) {
    this.idPlan = id;
  }
  goPlan(id: string, screen: string) {
    sessionStorage.setItem("idPlan", id);
    sessionStorage.setItem("PlanSelectionScreen", screen);
    this.router.navigate(['/iptv/1']);
  }
  showterms(offer: any) {
    if (sessionStorage.getItem("session") != null) {
      this.global.validateSession();
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.autoFocus = true;
    dialogConfig.data = { offer };
    this.dialog.open(PopUpTermsOffersComponent, dialogConfig);
  }

}
